import React from 'react';

import { Box, Flex, Text } from '@lucidhq/lucidium';

import { t } from '~/utils/i18n';

export const FileTypeInfo = () => (
  <Box>
    <Text>{t('campaignManager.media.uploadModal.supportedMedia')}</Text>
    <ul>
      <li>
        <Flex>
          <Text lss={{ fontWeight: 'bold', gap: '4px' }}>
            {t('campaignManager.media.uploadModal.images')}
          </Text>{' '}
          <Text>JPEG, JPG, PNG.</Text>
        </Flex>
      </li>
      <li>
        <Flex>
          <Text lss={{ fontWeight: 'bold' }}>
            {t('campaignManager.media.uploadModal.video')}
          </Text>{' '}
          <Text>MP4.</Text>
        </Flex>
      </li>
      <li>
        <Text>{t('campaignManager.media.uploadModal.fileSize')}</Text>
      </li>
    </ul>
  </Box>
);
